const url = "https://madmanpierre.com"
const formUrl = "https://form.maintenanceconnection.ca/"
const purchaseSuccessUrl = "/purchase-thanks"
const purchaseCancelUrl = "/purchase"
const bookSuccessUrl = "/book-thanks"
const bookCancelUrl = "/book"

export { url, formUrl, purchaseSuccessUrl, purchaseCancelUrl, bookSuccessUrl, bookCancelUrl }